import { Navigate, Route, Routes } from "react-router-dom";

import ArticlePage from "@/pages/IsfahanUni/article";
import ArticleDetailPage from "@/pages/IsfahanUni/article/detail";
import ArticleEditPage from "@/pages/IsfahanUni/article/edit";
import ArticleUrlPage from "@/pages/IsfahanUni/article/url";
import NewBook from "@/pages/IsfahanUni/book";
import UpdateUserInfoPage from "@/pages/IsfahanUni/update-user-info";
import CategoriesPage from "@/pages/category";
import ChangePasswordPage from "@/pages/change-password";
import DashboardHomePage from "@/pages/dashboard";
import ErrorPage from "@/pages/error";
import FormPage from "@/pages/form";
import FormEditorPage from "@/pages/form/editor";
import EntitiesPage from "@/pages/form/entities";
import FormFinal from "@/pages/form/final";
import SharedTableViewPage from "@/pages/form/final/share-view";
import FormsPage from "@/pages/form/forms";
import FormPreviewPage from "@/pages/form/preview";
import PropertiesPage from "@/pages/form/properties";
import LoginPage from "@/pages/login";
import MenuItemsPage from "@/pages/menu/menu-items";
import NotFoundPage from "@/pages/not-found";
import NotificationsPage from "@/pages/notification";
import NotificationContent from "@/pages/notification/content";
import EditOrganizationPage from "@/pages/organization/edit-organization";
import PasswordResetSuccess from "@/pages/password-reset-success";
import EditProfilePage from "@/pages/profile/edit-profile";
import EditProfileAboutMe from "@/pages/profile/edit-profile/about-me";
import EditProfileEducation from "@/pages/profile/edit-profile/education";
import EditProfileNewsMe from "@/pages/profile/edit-profile/news";
import EditProfileResearch from "@/pages/profile/edit-profile/research";
import EditProfileSocialLinks from "@/pages/profile/edit-profile/social-links";
import RolesPage from "@/pages/role";
import WorkflowsPage from "@/pages/workflow";
import WorkflowPage from "@/pages/workflow/flow";

import Layout from "@/components/layout/layout";

import AuthMiddleware from "./auth-middleware";

const Router = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/dashboard/login" element={<LoginPage />} />

      {/* Error Page - OUTSIDE of AuthMiddleware (no API calls) */}
      <Route path="/dashboard/error" element={<ErrorPage />} />

      {/* Reset password with token */}
      <Route
        path="/dashboard/reset-password/:token"
        element={<ChangePasswordPage />}
      />

      {/* Change password - conditional auth based on token or query params */}
      <Route
        path="/dashboard/change-password"
        element={<ChangePasswordPage />}
      />

      {/* Password reset success */}
      <Route
        path="/dashboard/password-reset-success"
        element={<PasswordResetSuccess />}
      />

      {/* Public shared table route */}
      <Route
        path="/dashboard/table-share/:shareCode"
        element={<SharedTableViewPage />}
      />

      {/* Change password (protected route - will be inside AuthMiddleware) */}
      {/* <Route
        path="/dashboard/change-password"
        element={<ChangePasswordPage />}
      /> */}

      {/* update article metric */}
      <Route
        path="/dashboard/update-user-info"
        element={<UpdateUserInfoPage />}
      />

      {/* Private routes */}
      <Route element={<AuthMiddleware />}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardHomePage />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="" element={<Navigate to="/dashboard" replace />} />

          {/* Edit Profile */}
          <Route path="/dashboard/edit-profile" element={<EditProfilePage />}>
            <Route index element={<EditProfileAboutMe />} />
            <Route path="research" element={<EditProfileResearch />} />
            <Route path="education" element={<EditProfileEducation />} />
            <Route path="social-links" element={<EditProfileSocialLinks />} />
            <Route path="news" element={<EditProfileNewsMe />} />
          </Route>

          {/* organization */}
          <Route
            path="/dashboard/organization/:unitName"
            element={<EditOrganizationPage />}
          />
          <Route
            path="/dashboard/organization"
            element={<EditOrganizationPage />}
          />

          {/* Form Creator  */}
          <Route path="/dashboard/form/" element={<FormPage />}>
            <Route index element={<FormsPage />} />
            <Route path="entities" element={<EntitiesPage />} />
            <Route path="entities/:entityId" element={<PropertiesPage />} />
            <Route path="editor/:formId" element={<FormEditorPage />} />
            <Route
              path="editor/:formId/preview"
              element={<FormPreviewPage />}
            />
          </Route>

          {/* Workflow Form Viewer */}
          <Route
            path="/dashboard/workflow-form/:workflowUserId"
            element={<FormFinal />}
          />

          {/* Workflow */}
          <Route path="/dashboard/workflow">
            <Route index element={<WorkflowsPage />} />
            <Route path=":workflowId" element={<WorkflowPage />} />
          </Route>

          {/* Roles */}
          <Route path="/dashboard/role">
            <Route index element={<RolesPage />} />
          </Route>

          {/* Categories */}
          <Route path="/dashboard/category">
            <Route index element={<CategoriesPage />} />
          </Route>

          {/* Notifications */}
          <Route path="/dashboard/notification">
            <Route index element={<NotificationsPage />} />
            <Route path=":notificationIdz" element={<NotificationContent />} />
          </Route>

          <Route path="/dashboard/menu">
            <Route index element={<MenuItemsPage />} />
          </Route>

          {/* Book  */}
          <Route path="/dashboard/new-book" element={<NewBook />}>
            <Route index element={<NewBook />} />
          </Route>

          {/* Article  */}
          <Route path="/dashboard/new-article" element={<ArticlePage />}>
            {/* <Route index element={<ArticleAutoPage />} /> */}
            {/* <Route path="scholar" element={<ArticleScholarPage />} /> */}
            {/* <Route path="url" element={<ArticleUrlPage />} /> */}
            <Route index element={<ArticleUrlPage />} />
          </Route>

          {/* Article  */}
          <Route path="/dashboard/article" element={<ArticlePage />}>
            <Route index element={<ArticleDetailPage />} />
            <Route path=":articleId" element={<ArticleDetailPage />} />
            <Route path="edit/:articleId" element={<ArticleEditPage />} />
          </Route>

          {/* Not Found Page */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default Router;
